// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useSelector } from 'react-redux';
import {
  DataTableV2, // eslint-disable-line no-unused-vars
  DataTableHeadV2, // eslint-disable-line no-unused-vars
  DataTableBodyV2, // eslint-disable-line no-unused-vars
  DataTableRowV2, // eslint-disable-line no-unused-vars
  DataTableHeadCellV2, // eslint-disable-line no-unused-vars
  DataTableCellV2, // eslint-disable-line no-unused-vars
  Heading, // eslint-disable-line no-unused-vars
} from '@americanexpress/dls-react';

const UserAccess = () => {
  const loginData = useSelector((state) => state.getIn([
      'modules',
      'axp-secure-file-express-root',
      'userData',
      'login',
    ])
  );

  const { userRoles = [] } = loginData;

  return (
    <div className="flex flex-column stack margin-4-t">
      <Heading level={4} theme={{ fontWeight: 500 }}>
        Roles Associated with Digital Assets Group
      </Heading>
      <DataTableV2
        sortable={true}
        bordered={true}
        id="tablev2-bordered-instance"
      >
        <DataTableHeadV2 sortable={true}>
          <DataTableRowV2>
            <DataTableHeadCellV2>Digital Assets Group</DataTableHeadCellV2>
            <DataTableHeadCellV2>Role</DataTableHeadCellV2>
            <DataTableHeadCellV2>Environment</DataTableHeadCellV2>
          </DataTableRowV2>
        </DataTableHeadV2>

        <DataTableBodyV2>
          {userRoles?.length > 0
            ? userRoles.map((userRole) => (
              <DataTableRowV2
                key={`${userRole.fxFamilyName}_${userRole.roleNm}_${userRole.env}`}
              >
                <DataTableCellV2>{userRole.fxFamilyName}</DataTableCellV2>
                <DataTableCellV2>{userRole.roleNm}</DataTableCellV2>
                <DataTableCellV2>{userRole.env}</DataTableCellV2>
              </DataTableRowV2>
            ))
           : (
             <DataTableRowV2>
               <DataTableCellV2 colSpan="12">
                 <div className="flex flex-align-center flex-justify-center">
                   No Data found
                 </div>
               </DataTableCellV2>
             </DataTableRowV2>
          )}
        </DataTableBodyV2>
      </DataTableV2>
    </div>
  );
};

export default UserAccess;
